import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/yerkir-next/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/services/acquisition.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/services/constraction.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/services/credit.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/services/design.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/services/purchasing.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/services/sold.svg");
